export function find<T>(array: Array<T>, pred: (t: T) => boolean): T {
  const found = array.find(pred);
  if (found === undefined) throw new Error("Element not found");
  return found;
}
